/* @flow */

import * as React from 'react';
import { injectIntl } from 'react-intl';
import { Input } from 'dibs-elements/exports/Input';
import formStyles from '../styles/FormGeneral.scss';

type ComponentProps<T> = {|
    intl: intlShape,
    errorMessage: string,
    placeholder: T,
    onChange: (e: SyntheticEvent<HTMLInputElement>) => void,
    value: string,
    marginRight?: boolean,
|};

export const MatchmakerInputComponent = <T: Object>({
    intl,
    errorMessage,
    placeholder,
    onChange,
    value,
    marginRight,
}: ComponentProps<T>) => {
    const name = intl.formatMessage(placeholder);
    const inputDataTn = 'matchmaker-' + { name }.toString();
    return (
        <div className={marginRight ? [formStyles.marginRight] : null}>
            <Input
                dataTn={inputDataTn}
                errorMessage={errorMessage}
                placeholder={name}
                name={name}
                defaultValue={value}
                onBlur={onChange}
                hasAnimatedPlaceholder
            />
        </div>
    );
};

export const MatchmakerInput = injectIntl(MatchmakerInputComponent);
